import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import ProgressDateText from '../../atoms/timeline/ProgressDateText';
const ProgressDate = ({ active, date, secondary, }) => (_jsxs(_Date, { active: active, children: [_jsx(ProgressDateText, { children: date }), secondary && _jsx("span", { children: secondary })] }));
const _Date = styled.div `
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: color 100ms ease-in-out;
    color: ${props => props.theme.primary.base};

    ${props => props.active &&
    css `
            color: ${props => props.theme.secondary};
        `};
`;
export default ProgressDate;
